import { Controller } from 'stimulus';

export default class extends Controller {
  static targets = ['indicator', 'save'];

  // `dirty` starts a form dirty: a card re-rendered after a failed save shows values that
  // were never saved, so they can't be the clean baseline.
  static values = { blocked: Boolean, dirty: Boolean };

  connect() {
    this.snapshot = this.#serialize();
    this.refreshHandler = () => this.refresh();
    this.element.addEventListener('input', this.refreshHandler);
    this.element.addEventListener('change', this.refreshHandler);
    this.refresh();
  }

  disconnect() {
    this.element.removeEventListener('input', this.refreshHandler);
    this.element.removeEventListener('change', this.refreshHandler);
  }

  blockedValueChanged() {
    this.refresh();
  }

  refresh() {
    if (this.snapshot === undefined) {
      return;
    }
    const dirty = this.dirtyValue || this.#serialize() !== this.snapshot;
    if (this.hasIndicatorTarget) {
      this.indicatorTarget.classList.toggle('hidden', !dirty);
    }
    if (this.hasSaveTarget) {
      this.saveTarget.disabled = !dirty || this.blockedValue;
    }
  }

  onSubmitEnd(event) {
    if (event.detail?.success) {
      this.dirtyValue = false;
      this.snapshot = this.#serialize();
      this.refresh();
    }
  }

  #serialize() {
    const form = this.element.querySelector('form');
    if (!form) {
      return '';
    }
    // jquery-ujs rewrites every form's authenticity_token on DOM ready, which can land after
    // connect() for a card rendered with the page, so the token would read as an edit.
    return JSON.stringify(
      Array.from(new FormData(form))
        .filter(([name]) => name !== 'authenticity_token')
        .map(([name, value]) =>
          value instanceof File ? [name, value.name, value.size] : [name, value]
        )
    );
  }
}
